import { modalButtonEvent } from '_fil/global-cms-modal/utils';
import $ from 'jquery';

$(document).ready(() => {
  $('.fil-cta fil-button').on('click', function() {
    const modal_id = $(this).attr('data-open');
    modalButtonEvent(modal_id);
  });
});
